// extracted by mini-css-extract-plugin
export default {"content":"Default_content__chXWk","grid":"Default_grid__ZZSiY","root":"Default_root__+7zCi","background":"Default_background__oYMZw"};